<template>
  <div id="messageListCheerSettingContainer">
    <div id="cheerBackgroundBoard" @click="closeMenu"></div>
    <div id="messageListCheerSettingMenu">
      <div id="menuCloseCheerButton" @click="closeMenu"></div>
      <div class="settingMenu" v-for="(menu, index) in cheerMenuItem" :key="index">
        <div class="settingMenuTitle">{{menu.menuTitle}}</div>
        <form>
          <div class="settingMenuItem" v-for="(item, index) in menu.items" :key="index" v-if="item.valueName ==='cheerMessage'">
            <div v-for="(value, index) in item.values" :key="index">
              <label :for="`cheer_${value.value}`">
                <input :id="`cheer_${value.value}`" :type="[item.valueName ==='cheerMessage' ? 'radio' : 'checkbox']" name="cheer" class="settingMenuItemValue" :value="value.value" :checked="value.selected" @click="e => updateSettingValue(e, item.valueName)">
                {{value.name}}
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'

export default {
  data: function () {
    return {
      cheerMenuItem: [
        {
          'menuTitle': '응원채팅 설정',
          'items': [
            {
              'itemName': '전체',
              'valueName': 'cheerMessage',
              'values': [
                {'name': 'on', 'value': 'Y', 'selected': Cookies.get('cheerView') !== 'N'},
                {'name': 'off', 'value': 'N', 'selected': Cookies.get('cheerView') === 'N'}
              ]
            },
            {
              'itemName': '종목',
              'valueName': 'topic',
              'values': [
                {'name': '축구', 'value': 'soccer', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('soccer')},
                {'name': '농구', 'value': 'basketball', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('basketball')},
                {'name': '배구', 'value': 'volleyball', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('volleyball')},
                {'name': '하키', 'value': 'hockey', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('hockey')},
                {'name': '미식축구', 'value': 'football', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('football')}
                // {'name': '야구', 'value': 'baseball', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('baseball')},
                // {'name': 'LOL', 'value': 'lol', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('lol')},
                // {'name': '스타', 'value': 'star', 'selected': !Cookies.get('cheerFilter') || !~Cookies.get('cheerFilter').indexOf('star')}
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    closeMenu: function (event) {
      // console.log(this)
      this.$el.style.opacity = '0'
      this.$el.style.visibility = 'hidden'
    },
    updateSettingValue: function (event, itemValue) {
      if (itemValue === 'cheerMessage') { // 응원채팅 전체 끄기/켜기
        const settingValue = event.target.value
        if (settingValue === Cookies.get('cheerView')) return
        Cookies.set('cheerView', settingValue, {path: '/', expires: 365})
        this.$store.dispatch('addMessage', {'msg': `응원채팅이 ${settingValue === 'N' ? '비' : ''}활성화 되었습니다.`, 'style': 'notify'})
        this.$el.style.opacity = '0'
        this.$el.style.visibility = 'hidden'
      } else { // 응원채팅 종목별 끄기/켜기
        const isSubscription = event.target.checked
        const subscriptionTopic = event.target.value
        if (window.ws_sub) {
          window.ws_sub.send(`${isSubscription ? '' : 'UN'}SUB sports.${subscriptionTopic}.cheers`)
        }
        let noSubTopic = Cookies.get('cheerFilter')
        if (!noSubTopic) {
          noSubTopic = subscriptionTopic
        } else {
          const topicArray = noSubTopic.split('_')
          if (isSubscription) {
            const filterTopic = topicArray.filter(v => v !== subscriptionTopic)
            const cookieValue = filterTopic.reduce((next, accString) => {
              return accString + `_${next}`
            }, '')
            noSubTopic = cookieValue.charAt(cookieValue.length - 1) === '_' ? cookieValue.slice(0, cookieValue.length - 1) : cookieValue
          } else {
            if (!topicArray.some(topic => topic === subscriptionTopic)) {
              noSubTopic += '_' + subscriptionTopic
            }
          }
        }
        Cookies.set('cheerFilter', noSubTopic, {path: '/', expires: 365})
      }
    }
  },
  mounted () {
    try {
      var configData = JSON.parse(decodeURIComponent(Cookies.get('new_chat_config')))
      if (configData !== undefined) {
        this.menuItem[0].items = configData
      }
    } catch (error) {
      // console.error('chat-message-setting-menu mounted ERROR', error)
    }
  }
}
</script>

<style lang="scss">
#messageListCheerSettingContainer {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index:1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  #menuCloseCheerButton {
    display: block;
    width: 17px;
    height: 17px;
    background: url(/nlivechat/img/sp_chat.png) no-repeat 0 -290px;
    text-indent: -9999px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 3px;
    margin: 17px;
    cursor: pointer;
  }
  #cheerBackgroundBoard {
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
  }
  #messageListCheerSettingMenu {
    position: fixed;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
    width: 80%;
    min-width: 270px;
    .settingMenu {
      display: block;
      padding: 0 20px 20px;
      background-color: #fff;
      overflow: visible;
      form {
        overflow: hidden;
      }
      .settingMenuTitle {
        height: 51px;
        line-height: 51px;
      }
      .settingMenuItem {
        overflow:hidden;
        clear:both;
        span, div {
          float: left;
        }
        span {
          width: 60px;
          margin: 0 0 0 3%;
        }
        div {
          padding:10px 0;
          margin: 0 3% 0 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-message-cheer-setting.vue?00c2f6f3